import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../data/mock';

const FAQ = () => {
  const [open, setOpen] = useState(0);
  const half = Math.ceil(faqs.length / 2);
  const cols = [faqs.slice(0, half), faqs.slice(half)];

  return (
    <section className="bg-[#FAF2E8] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 mb-10">
          Frequently Asked{' '}
          <span className="relative inline-block text-[#F39200]">Questions
            <svg className="absolute -bottom-2 left-0 w-full" height="10" viewBox="0 0 280 10" fill="none">
              <path d="M2 7 C 70 1, 160 1, 278 6" stroke="#F39200" strokeWidth="2" strokeLinecap="round" fill="none" />
            </svg>
          </span>
        </h2>

        <div className="grid md:grid-cols-2 gap-x-10">
          {cols.map((col, ci) => (
            <div key={ci} className="divide-y divide-neutral-200">
              {col.map((f, i) => {
                const idx = ci * half + i;
                const isOpen = open === idx;
                return (
                  <div key={f.q} className="py-4">
                    <button
                      onClick={() => setOpen(isOpen ? -1 : idx)}
                      className="w-full flex items-start gap-4 text-left"
                    >
                      <span className="mt-1 shrink-0 w-7 h-7 rounded-full bg-white border border-neutral-200 flex items-center justify-center text-neutral-700">
                        {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                      </span>
                      <span className={`text-[15px] md:text-base font-medium ${isOpen ? 'text-[#F39200]' : 'text-neutral-900'}`}>{f.q}</span>
                    </button>
                    {isOpen && (
                      <p className="mt-3 ml-11 text-sm text-neutral-600 leading-relaxed">{f.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
